import { TimeInputSection } from '@/modules/expiring-fans/components/time-input-section.tsx'
import { useDebouncedProperty } from '@/utils/useDebouncedProperty.ts'

interface Props {
  hoursBeforeExpiry: number
  changeHoursBeforeExpiry: (hoursBeforeExpiry: number) => void
  disabled?: boolean
}
export const MessageTimingController = ({
  hoursBeforeExpiry,
  changeHoursBeforeExpiry,
  disabled,
}: Props) => {
  const [currentHoursBeforeExpiry, setHoursBeforeExpiry] = useDebouncedProperty<
    number | undefined
  >(hoursBeforeExpiry, (value) => changeHoursBeforeExpiry(value ?? 0))

  return (
    <TimeInputSection
      title="Message Timing"
      description="The time before the fans' expiry during which they will receive the message"
      value={currentHoursBeforeExpiry}
      onChange={setHoursBeforeExpiry}
      textClassName="max-w-[8rem]"
      disabled={disabled}
    />
  )
}
